import {recoverObsoleteCustomerOffer} from "@project/sdk/sales";
import {RecoverObsoleteCustomerOfferResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function recoverObsoleteCustomerOfferMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.recoverObsoleteCustomerOffer,
    mutationFn: async (id: string) =>
      RecoverObsoleteCustomerOfferResponse.parse(await recoverObsoleteCustomerOffer(id)),
    onSuccess: async (_result, ownerId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(ownerId)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
